import React from 'react';
import { ProjectLogsHeader } from './ProjectLogsHeader';
import { ProjectLogsList } from './ProjectLogsList';
import { ProjectLogsSidebar } from './ProjectLogsSidebar';
import { useProjectLogs } from '../hooks/useProjectLogs';

export function ProjectLogsMain() {
  const { data, isLoading } = useProjectLogs();

  if (isLoading) {
    return <div className="p-10 text-center text-slate-400">Đang tải nhật ký hoạt động...</div>;
  }

  return (
    <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
      {/* Nội dung chính: Danh sách nhật ký */}
      <div className="xl:col-span-9 space-y-6">
        <ProjectLogsHeader />
        <ProjectLogsList logs={data.logs} />
      </div>

      {/* Sidebar: Thống kê hoạt động */}
      <div className="xl:col-span-3">
        <ProjectLogsSidebar data={data} />
      </div>
    </div>
  );
}
